module.exports = __webpack_public_path__ + "static/img/ico.ad4c469.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ico.png
// module id = lLGQ
// module chunks = 18